import { useSearchParams } from "@solidjs/router";
import { Show } from "solid-js";
import { singleParam } from "../../ui/searchParam";
import { ModuleShell } from "../scan/ModuleShell";
import { createWebsiteStore } from "../website/store";
import { BriefPreview } from "./BriefPreview";

export function BriefWorkspace(props: { websiteId: string }) {
  const context = createWebsiteStore(props.websiteId);
  const [search] = useSearchParams();
  const mapRequested = () => singleParam(search.source) === "map";
  const issueRequested = () => singleParam(search.source) === "issue";
  const requestedIssueId = () =>
    issueRequested() ? singleParam(search.issueId) : null;

  return (
    <ModuleShell
      context={context}
      activeModule="brief"
      workspaceClass="signal-workspace signal-brief-workspace"
    >
      <Show
        when={context.data()}
        keyed
        fallback={
          <div class="loading signal-loading">Loading delivery briefs...</div>
        }
      >
        {(data) => (
          <BriefPreview
            data={data}
            websiteId={props.websiteId}
            mapRequested={mapRequested()}
            issueRequested={issueRequested()}
            requestedIssueId={requestedIssueId()}
          />
        )}
      </Show>
    </ModuleShell>
  );
}
